var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTagSearch = function SvgTagSearch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.883 18.889l-3.184-3.16.197-.265.005-.007c.035-.047.07-.094.103-.141l.004-.005c1.247-1.77.971-4.273-.678-5.9A4.883 4.883 0 0 0 12.879 8a4.877 4.877 0 0 0-3.45 1.412A4.753 4.753 0 0 0 8 12.818c0 1.287.507 2.496 1.429 3.406a4.868 4.868 0 0 0 3.442 1.408c.78 0 1.557-.186 2.252-.542a3.91 3.91 0 0 0 .495-.324l3.233 3.12a.41.41 0 0 0 .276.114c.066 0 .166-.02.262-.112l.161-.154c.124-.117.254-.24.346-.332.18-.178.093-.403-.013-.513m-7.026-9.592c1.964 0 3.562 1.577 3.562 3.517s-1.598 3.517-3.562 3.517c-1.964 0-3.563-1.578-3.563-3.518 0-1.939 1.599-3.516 3.563-3.516"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTagSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tag-search.307de7d0933a887d840f77d938e0e9e4.svg";